import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useEmployeeUrl } from 'domain/shared/employee';
import usePerformanceReportService from '../usePerformanceReportService';

const PerformanceHeatmapLabels = ({ labels }: { labels: Array<Dictionary<string>> }) => {
  const { getTimelineUrl } = useEmployeeUrl();
  const { isFakeId } = usePerformanceReportService();

  return (
    <Box
      component="ul"
      className="performance-heatmap__labels"
      sx={{
        gridTemplateRows: `repeat(${labels.length}, var(--square-size))`,
      }}
    >
      {labels.map(({ userId, userName }) => (
        <li key={userId} title={userName}>
          {!isFakeId(userId) ? <Link to={getTimelineUrl(userId)}>{userName}</Link> : <p>{userName}</p>}
        </li>
      ))}
    </Box>
  );
};

export default PerformanceHeatmapLabels;
